module.exports = __webpack_public_path__ + "img/logo-card-contact2.99a3c70a.jpg";